/* eslint-disable @typescript-eslint/no-restricted-types */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Consumer, Subscription, createConsumer } from '@rails/actioncable';

export enum Channel {
  UniversalSubmit = 'UniversalSubmitChannel',
}

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private consumer: Consumer;

  subscribe(channel: Channel, id: string, received: Function): Subscription {
    this.connect();

    return this.consumer.subscriptions.create(
      { channel, id },
      {
        connected: () => {
          console.log('Websocket connected');
        },
        disconnected: () => {
          console.log('Websocket disconnected');
        },
        received: (data: any) => {
          received(data);
        },
      },
    );
  }

  unsubscribeFromChannel(channel: Channel, id?: string): void {
    if (!this.consumer) return;

    const subs = this.consumer.subscriptions.subscriptions;

    const matchingSubs = subs.filter((sub) => {
      const identifier = JSON.parse(sub.identifier);
      return (
        identifier.channel === channel && (id ? identifier.id === id : true)
      );
    });

    matchingSubs.forEach((sub) => sub.unsubscribe());

    if (this.consumer.subscriptions.subscriptions.length === 0) {
      this.consumer.disconnect();
    }
  }

  connect(): void {
    if (!this.consumer) {
      this.consumer = createConsumer(`${environment.apiBaseUri}/cable`);
      this.consumer.ensureActiveConnection();
    }
  }
}
